export const LENS_NAVIGATION_DIRECTION = {
  Previous: "previous",
  Next: "next"
} as const;

export type LensNavigationDirection =
  typeof LENS_NAVIGATION_DIRECTION[keyof typeof LENS_NAVIGATION_DIRECTION];
